<div class="modal-header">
  <h4 class="modal-title heading-5" id="modal-basic-title">
    {{
      (editing
        ? type + ".edit-" + type + ".edit-" + type
        : type + ".create-" + type + ".create-" + type
      ) | translate
    }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body p-4">
  <!-- <div class="row" *ngIf="isAdmin">
        <div class="col-12">
            <app-create-travel-modal [customBooking]="isAdmin ? true : false" [userUuid]="isAdmin ? userId : null"
                (sendInfo)="handleTravel($event)"></app-create-travel-modal>
        </div>
    </div>
    <hr /> -->
  <form
    [formGroup]="form"
    [ngClass]="{ 'loading-background': loading }"
    (ngSubmit)="form.valid && !loading ? onSubmit() : (isInvalid = true)"
  >
    <div class="row mt-2" *ngIf="editing && (userType?.toLowerCase() === 'employee' || userType?.toLowerCase() === 'company')">
      <div class="col-12">
        <div class="form-group passenger-select">
          <label class="pt-0" for="passenger">{{ "common.traveller" | translate }}</label>

          <mat-select
            id="passenger"
            formControlName="passenger"
            (openedChange)="!$event && resetUsersFilter()"
            class="form-control custom-select"
          >
            <mat-option class="search-option" disabled>
              <input
                class="custom-mat-input"
                matInput
                (input)="applyFilter($event.target.value)"
                (click)="$event.stopPropagation()"
                placeholder="{{ 'common.search-user' | translate }}"
              />
            </mat-option>

            <mat-option *ngFor="let user of filteredUsers" [value]="user.uuid">
              {{ user.name }} {{ user.lastname }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-6">
        <div class="form-group input-file">
            <input
              formControlName="file"
              type="file"
              id="file"
              class="inputFile"
              (change)="onFileChange($event)"
              accept="application/pdf"
              multiple
            />
            <label for="file" class="px-3 py-1 labelFile" [class.disabled]="userType !== 'EMPLOYEE' && isEdit">{{
              type + ".create-" + type + ".choose-file" | translate
            }}</label>
            <div class="file-tags" *ngIf="(files?.length > 0 || existingFiles?.length > 0); else showFileBack">
              <span *ngFor="let f of existingFiles; let i = index" class="file-tag">
                {{ f.name }}
                <button type="button" class="remove-btn" (click)="removeFile(i)">x</button>
              </span>
              <span *ngFor="let f of files; let i = index" class="file-tag">
                {{ f.name }}
                <button type="button" class="remove-btn" (click)="removeFile(i)">x</button>
              </span>
            </div>
            <ng-template #showFileBack>
              <label class="pl-3" *ngIf="fileBack">
                {{ fileBack.name }}
              </label>
            </ng-template>
          </div>
      </div>
      <div class="col-6 pd" *ngIf="isAdmin">
        <div class="form-group price-container">
          <mat-checkbox class="example-margin" formControlName="freeTaxes">
            <small>{{ "car.free-taxes" | translate }}</small>
          </mat-checkbox>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="userType === 'EMPLOYEE' && isAdmin" style="margin-top: 1rem;">
      <div class="col-6">
        <div class="form-group">
          <label>{{ 'company.company-booked.wholesale-price' | translate }}</label>
          <input
            formControlName="wholesalePrice"
            type="text"
            id="wholesalePrice"
            class="form-control"
            placeholder="{{ 'company.company-booked.wholesale-price' | translate }}"
            [ngClass]="{
              'input-error':
                !form.controls.wholesalePrice.valid &&
                isInvalid &&
                !form.controls.wholesalePrice.disabled
            }"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>{{ type + '.form-' + type + '.price' | translate }}</label>
          <input
              formControlName="price"
              type="text"
              placeholder="{{ type + '.form-' + type + '.price' | translate }}"
              id="price"
              class="form-control"
              [ngClass]="{
                'input-error':
                  !form.controls.price.valid &&
                  isInvalid &&
                  !form.controls.price.disabled
              }"
            />
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-6">
        <div class="form-group">
          <label>{{ type + '.form-' + type + '.origin' | translate }}</label>
          <input
            formControlName="from"
            placeholder="{{ type + '.form-' + type + '.origin' | translate }}"
            type="text"
            id="from"
            class="form-control"
            matInput
            [matAutocomplete]="fromAuto"
            (input)="getCities($event.target.value)"
            [ngClass]="{
              'input-error': !form.controls.from.valid && isInvalid
            }"
          />
          <mat-autocomplete
            #fromAuto="matAutocomplete"
            panelWidth="20%"
            (optionSelected)="cleanCitiesList()"
          >
            <mat-option *ngFor="let option of citiesList" [value]="option">
              {{ option }}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>{{ type + '.form-' + type + '.destination' | translate }}</label>
          <input
            formControlName="to"
            placeholder="{{
              type + '.form-' + type + '.destination' | translate
            }}"
            type="text"
            id="to"
            class="form-control"
            matInput
            [matAutocomplete]="toAuto"
            (input)="getCities($event.target.value)"
            [ngClass]="{
              'input-error': !form.controls.to.valid && isInvalid
            }"
          />
          <mat-autocomplete
            #toAuto="matAutocomplete"
            panelWidth="20%"
            (optionSelected)="cleanCitiesList()"
          >
            <mat-option *ngFor="let option of citiesList" [value]="option">
              {{ option }}
            </mat-option>
          </mat-autocomplete>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-6">
        <div class="form-group">
          <label>{{ type + '.form-' + type + '.date-departure' | translate }}</label>
          <input
            class="form-control filter-dates-placeholder"
            [disabled]="this.userType != 'EMPLOYEE' && isEdit"
            readonly
            placeholder="{{
              type + '.form-' + type + '.date-departure' | translate
            }}"
            name="departDate"
            id="departDate"
            formControlName="departDate"
            ngbDatepicker
            #dDeparture="ngbDatepicker"
            (click)="dDeparture.toggle()"
            [minDate]="minDateNgStruct"
            [maxDate]="maxDateNgStruct"
            [ngClass]="{
              'input-error': !form.controls.departDate.valid && isInvalid
            }"
          />
          <div class="mt-2">
            <ngb-timepicker
              formControlName="timeDepart"
              [spinners]="false"
            ></ngb-timepicker>
            <div *ngIf="!form.controls.timeDepart.valid && isInvalid">
              {{"common.required" | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>{{ type + '.form-' + type + '.date-return' | translate }}</label>
          <input
            readonly
            [disabled]="f.departDate.hasError('required') || (this.userType != 'EMPLOYEE' && isEdit)"
            [ngClass]="{ dates: !f.departDate.hasError('required') }"
            class="form-control filter-dates-placeholder"
            placeholder="{{
              type + '.form-' + type + '.date-return' | translate
            }}"
            name="returnDate"
            id="returnDate"
            formControlName="returnDate"
            ngbDatepicker
            #dReturn="ngbDatepicker"
            (click)="dReturn.toggle()"
            [minDate]="getOutDate()"
            [maxDate]="maxDateNgStruct"
            [ngClass]="{
              'input-error': !form.controls.returnDate.valid && isInvalid && !form.controls.returnDate.disabled
            }"
          />
          <div class="mt-2">
            <ngb-timepicker
              [readonlyInputs]="f.departDate.hasError('required')"
              formControlName="timeReturn"
              [spinners]="false"
            ></ngb-timepicker>
            <div *ngIf="!form.controls.timeReturn.valid && isInvalid && !form.controls.timeReturn.disabled">
              {{"common.required" | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-6">
        <div class="form-group createCarSelectContainer">
          <label>{{ 'car.custom.request.carType.holder' | translate }}</label>
          <mat-select
            class="form-control"
            placeholder="{{ 'car.custom.request.carType.holder' | translate }}"
            formControlName="carType"
            [ngClass]="{
              'input-error': !form.controls.carType.valid && isInvalid
            }"
          >
            <mat-option *ngFor="let type of carType" [value]="type.value">
              {{ type.viewValue }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <div>
            <label>{{ type + '.form-' + type + '.age' | translate }}</label>
            <input
              formControlName="age"
              placeholder="{{ type + '.form-' + type + '.age' | translate }}"
              type="number"
              id="age"
              class="form-control"
              [ngClass]="{
                'input-error': !form.controls.age.valid && isInvalid
              }"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-6">
        <div class="form-group createCarSelectContainer">
          <label>{{ 'car.custom.request.pickup.titleFrom-holder' | translate }}</label>
          <mat-select
            class="form-control"
            placeholder="{{
              'car.custom.request.pickup.titleFrom-holder' | translate
            }}"
            formControlName="pickupPlaceFrom"
            [ngClass]="{
              'input-error': !form.controls.pickupPlaceFrom.valid && isInvalid
            }"
          >
            <mat-option
              *ngFor="let place of pickupOptions"
              [value]="place.value"
            >
              {{ place.viewValue }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group createCarSelectContainer">
          <label>{{ 'car.custom.request.pickup.titleTo-holder' | translate }}</label>
          <mat-select
            class="form-control"
            placeholder="{{
              'car.custom.request.pickup.titleTo-holder' | translate
            }}"
            formControlName="pickupPlaceTo"
            [ngClass]="{
              'input-error': !form.controls.pickupPlaceTo.valid && isInvalid
            }"
          >
            <mat-option
              *ngFor="let place of pickupOptions"
              [value]="place.value"
            >
              {{ place.viewValue }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-6">
        <div class="form-group">
          <label>{{ 'my-bookeds.view.provider' | translate }}</label>
          <mat-form-field style="font-size: small;" appearance="fill" class="full-width travellers no-bottom">
            <mat-select
              formControlName="provider"
              [compareWith]="providerCompare"
              [disabled]="loadingCarProviders"
              placeholder="{{ 'my-bookeds.view.provider' | translate }}">

              <mat-option *ngIf="!loadingCarProviders && !carProviderOptions.length" disabled>
                {{ "common.no-providers-available" | translate }}
              </mat-option>

              <mat-option *ngFor="let opt of carProviderOptions" [value]="opt.uuid">
                {{ opt.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="col-6" style="display: flex; align-items: center;">
        <div class="checkbox-container">
          <mat-checkbox
            class="example-margin"
            formControlName="insuranceWithExcess"
          >
            <small>{{ "car.insuranceWithExcess" | translate }}</small>
          </mat-checkbox>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-lg-6 col-md-6 col-xs-12">
        <div class="form-group">
          <label>{{ 'common.custom-code' | translate }}</label>
          <input
            formControlName="customCode"
            placeholder="{{ 'common.custom-code' | translate }}"
            type="text"
            id="customCode"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12">
        <div class="form-group">
          <label>{{ 'common.cost-center' | translate }}</label>
          <input
            formControlName="costCenter"
            placeholder="{{ 'common.cost-center' | translate }}"
            type="text"
            id="costCenter"
            class="form-control"
          />
        </div>
      </div>
    </div>
    <div class="row mt-2" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-lg-6 col-md-6 col-xs-12" style="display: flex; align-items: center;">
        <div class="form-group" style="width: 100% !important;">
          <label>{{ 'company.bills.supplier-invoice' | translate }}</label>
          <input
            formControlName="supplierInvoice"
            placeholder="{{ 'company.bills.supplier-invoice' | translate }}"
            type="text"
            id="supplierInvoice"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12" style="display: flex; align-items: center; padding-bottom: 1rem;">
        <div class="form-group" style="width: 100% !important;">
          <label>{{ 'company.company-booked.booking-type' | translate }}</label>
          <mat-form-field appearance="fill" class="full-width travellers booktype-compact" floatLabel="never">
            <mat-select formControlName="bookType" [disabled]="loading" placeholder="{{
              'company.company-booked.booking-type' | translate
            }}">
              <mat-option value="automatic">{{ 'common.automatic-book' | translate }}</mat-option>
              <mat-option value="semiautomatic">{{ 'common.semiautomatic-book' | translate }}</mat-option>
              <mat-option value="manual">{{ 'common.manual-book' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-lg-6 col-md-6 col-xs-12" style="display: flex; align-items: center; padding-bottom: 1rem;">
        <div class="form-group" style="width: 100% !important;">
          <label>{{ 'company.company-booked.invoiced-status' | translate }}</label>
          <mat-form-field
            appearance="fill"
            class="full-width travellers booktype-compact"
            floatLabel="never"
          >
            <mat-select
              formControlName="invoiced"
              [disabled]="loading"
              placeholder="{{ 'company.company-booked.invoiced-status' | translate }}"
            >
              <mat-option value="none">
                {{ 'company.company-booked.invoiced-none' | translate }}
              </mat-option>
              <mat-option value="invoiced">
                {{ 'company.company-booked.invoiced-invoiced' | translate }}
              </mat-option>
              <mat-option value="proforma">
                {{ 'company.company-booked.invoiced-proforma' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-12">
        <div class="form-group">
          <textarea
            formControlName="comments"
            id="comments"
            class="textarea form-control"
            placeholder="{{
              type + '.form-' + type + '.annotations-request' | translate
            }}"
            rows="4"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-end">
          <button
            class="custom-btn mb-0"
            ngbAutofocus
            mat-button
            [ngStyle]="{
              cursor: !form.valid || loading ? 'not-allowed' : 'pointer'
            }"
            [ngClass]="{
              'disabled-button': !form.valid || loading
            }"
          >
            {{ "common.send" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="row" *ngIf="loading">
    <app-loading [userType]="'employee'"></app-loading>
  </div>
</div>
